import React from "react";
import errorImg from "../../assets/images/error.png";

const ErrorModal = ({ error = "", onClose }) => {
  if (!error) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div className="bg-white rounded-lg max-w-sm w-full sm:pt-5 pt-8 p-6 shadow-lg relative">
        <button
          className="absolute top-2 right-3 text-gray-500 hover:text-gray-700 text-xl"
          onClick={onClose}
        >
          &times;
        </button>
        <div className="w-full max-h-[70vh] flex flex-col items-center text-center overflow-y-auto">
          <img src={errorImg} className="w-32 h-auto m-4" alt="Error" />
          <div className="w-full text-red-600">
            <p dangerouslySetInnerHTML={{ __html: error }} />
          </div>
        </div>
      </div>
    </div>
  );
};

export default ErrorModal;
